import React from 'react';
import { Link } from 'react-router-dom';
import { PageSlug, usePageHref } from '../api/pages';

type PageLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  slug: PageSlug;
};

/**
 * Link to the Privacy Policy / Terms page at its current (admin-editable)
 * address — a route on this site, or a plain link when it's on another domain.
 */
const PageLink: React.FC<PageLinkProps> = ({ slug, children, ...props }) => {
  const { href, external } = usePageHref(slug);
  if (external) {
    return (
      <a href={href} rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} {...props}>
      {children}
    </Link>
  );
};

export default PageLink;
